import { useCallback } from "react";

const useSearchMark = ( markClass: string = "rdc_txtmark" ) => {

	const getHtml = useCallback( ( source: string, searchText: string ): string => {
		if ( !!source && !!searchText ) {
			let search = searchText.replace(new RegExp(/0x00[0-9A-F]{2}/, 'gi'), fromHex);
			search = prepareSearchString(search);
			search = escapeRegexpSpecials(search);
			let modifiedValue = source;
			const searchArray = search.split(' ');
			for ( let i = 0; i < searchArray.length; i++ ) {
				if ( searchArray[i].length === 0) {
					continue;
				}
				const searchItem = buildRegexpString(searchArray[i]);
				modifiedValue = modifiedValue.replace(new RegExp(searchItem, 'gi'), t => replacer( t, markClass ) );
			}
			return modifiedValue;
		}
		return source;
	}, [ markClass ] );

	return { getHtml } as const;
};

const fromHex = ( substring: any ): string => String.fromCharCode(substring);
const replacer = ( text: string, markClass: string ): string => `<mark class="${markClass}">${text}</mark>`;

const escapeRegexpSpecials = ( text: string ): string => text.replace(/\\/g, '\\\\')
	.replace(/\+/g, '\\+')
	.replace(/\*/g, '\\*')
	.replace(/\?/g, '\\?')
	.replace(/\(/g, '\\(')
	.replace(/\)/g, '\\)')
	.replace(/\[/g, '\\[')
	.replace(/\]/g, '\\]');

// eslint-disable-next-line			
const prepareSearchString = ( text: string ): string => text.replace(/[-\\(\\)"\'«»:;\/_+.,]/g, ' ').replace(/ё/gi, 'е');

const buildRegexpString = ( text: string ): string => {
	const initBoundary = '(?<=^|\\s|-|\\(|\\)|"|\'|«|»|:|;|/|_|\\+|\\.|,)';
	if ( text.length > 5 ) {
		return initBoundary + text.substring(0, text.length - 3) + '[а-яёa-z]{0,5}';
	} 
	else if ( text.length < 4 ) {
		return initBoundary + text;
	} 
	else if ( text.length === 4 || text.length === 5 ) {
		return initBoundary + text;;
	}
	return text;
};

export default useSearchMark;
